import { makeRequestAction } from './actions';
import { DECLINE } from '../constants/Actions';

export default ({ conversationId, reason = '' }) => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(makeRequestAction.start({ type: DECLINE }));

  return apiV2
    .declineConversation(conversationId, { reason })
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(
      ([
        data,
        {
          data: { messages },
        },
      ]) => {
        dispatch(makeRequestAction.done({ ...data, messages }));
      },
    )
    .catch(error => dispatch(makeRequestAction.error(error)));
};
